export const PROFILE_CONSTANT_REQUEST = "PROFILE_CONSTANT_REQUEST";
export const PROFILE_CONSTANT_SUCCESS = "PROFILE_CONSTANT_SUCCESS";
export const PROFILE_CONSTANT_FAIL = "PROFILE_CONSTANT_FAIL";
export const PROFILE_CONSTANT_RESET = "PROFILE_CONSTANT_RESET";
